import classnames from "classnames";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import Markdown from "components/shared/Markdown";
import {Task} from "v2/api/Records";

const Tasks = (props) => {
  const {data} = props;

  let content;
  if (data && !data.isEmpty()) {
    content = (
      <ul className="erg-list erg-checkmark-list">
        {data.map(task => (
          <li
            className={classnames({"erg-checkmark-list-unchecked": !task.completed})}
            key={`task-${task.id}`}>
            <Markdown inline>{task.title}</Markdown>
            {task.description &&
              <Markdown className="TaskDescription">
                {task.description}
              </Markdown>}
          </li>
        ))}
      </ul>
    );
  } else {
    content = (
      <span className="text-muted">
        Destination doesn&apos;t have any Tasks.
      </span>
    );
  }

  return (
    <div>
      <h5 className="text-uppercase">Tasks</h5>
      {content}
    </div>
  );
};

Tasks.propTypes = {
  data: ImmutablePropTypes.listOf(Task),
};

export default Tasks;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/Tasks.js
 **/